import { render, staticRenderFns } from "./ModalDiscount.vue?vue&type=template&id=136c7520&scoped=true&"
import script from "./ModalDiscount.vue?vue&type=script&lang=js&"
export * from "./ModalDiscount.vue?vue&type=script&lang=js&"
import style0 from "./ModalDiscount.vue?vue&type=style&index=0&id=136c7520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136c7520",
  null
  
)

export default component.exports